<template>
  <div></div>
</template>

<script>
import { ONLINE_STATUS } from "@/constants";
import { database, firestore } from "@/services/firebase";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      tournaments: null,
      liveMatches: [],
    };
  },

  firestore: {
    tournaments: firestore
      .collection("tournaments")
      .where("isDeleted", "==", false),
    liveMatches: firestore.collection("matches").where("status", "==", "live"),
  },

  watch: {
    isIdle(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateOnlineStatus();
    },
    isAway(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateOnlineStatus();
    },
    isPlayingMatch(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateOnlineStatus();
    },
    isPlayingTournament(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateOnlineStatus();
    },
    isBusy(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.updateOnlineStatus();
    },

    playingMatch() {
      this.setIsPlayingMatch(!!this.playingMatch);
    },

    playingTournament() {
      this.setIsPlayingTournament(!!this.playingTournament);
    },
  },

  computed: {
    ...mapGetters({
      userId: "getUserId",
      currentPlayer: "getPlayer",
      isIdle: "getIsIdle",
      isAway: "getIsAway",
      isPlayingMatch: "getIsPlayingMatch",
      isPlayingTournament: "getIsPlayingTournament",
      isBusy: "getIsBusy",
    }),

    // current playing match
    playingMatch() {
      if (!this.liveMatches || !this.liveMatches.length) return;

      return this.liveMatches.find(
        (m) =>
          !m.result &&
          ((m.player1 && m.player1.user_id === this.userId) ||
            (m.player2 && m.player2.user_id === this.userId))
      );
    },

    playingTournament() {
      if (!this.tournaments || !this.tournaments.length) return null;

      const activeTournaments = this.tournaments.filter(
        (t) => t.currentRound <= t.totalRounds
      );

      if (!activeTournaments || !activeTournaments.length) return null;

      if (!this.currentPlayer) return null;

      // find a tournament that is going to start in about 12 hour
      return activeTournaments.find(
        (t) =>
          t.playerUsernames &&
          t.playerUsernames.includes(this.currentPlayer.username) &&
          t.startTime.toDate().getTime() - Date.now() < 12 * 60 * 60 * 1000 // show in the date only
      );
    },
  },

  methods: {
    ...mapActions([
      "setOnlineStatus",
      "setIsPlayingMatch",
      "setIsPlayingTournament",
    ]),

    async changeOnlineStatusToAway() {
      const databaseRef = database.ref(`rooms/lobby/players/${this.userId}`);
      if (!databaseRef) return;

      const onlineStatus = await databaseRef.get();
      if (!onlineStatus.exists()) {
        // not online, don't care
        return;
      }

      await this.changeStatusTo(ONLINE_STATUS.AWAY);
    },

    async changeOnlineStatusToActive() {
      const databaseRef = database.ref(`rooms/lobby/players/${this.userId}`);
      if (!databaseRef) return;

      const onlineStatus = await databaseRef.get();
      if (!onlineStatus.exists()) {
        // not online, don't care
        return;
      }

      await this.changeStatusTo(ONLINE_STATUS.ACTIVE);
    },

    async changeOnlineStatusToPlaying() {
      const databaseRef = database.ref(`rooms/lobby/players/${this.userId}`);
      if (!databaseRef) return;

      const onlineStatus = await databaseRef.get();
      if (!onlineStatus.exists()) {
        // not online, don't care
        return;
      }

      await this.changeStatusTo(ONLINE_STATUS.PLAYING);
    },

    async changeOnlineStatusToBusy() {
      const databaseRef = database.ref(`rooms/lobby/players/${this.userId}`);
      if (!databaseRef) return;

      const onlineStatus = await databaseRef.get();
      if (!onlineStatus.exists()) {
        // not online, don't care
        return;
      }

      await this.changeStatusTo(ONLINE_STATUS.BUSY);
    },

    async changeStatusTo(status) {
      const databaseRef = database.ref(`rooms/lobby/players/${this.userId}`);

      if (!databaseRef) return;

      await this.setOnlineStatus(status);
      await databaseRef.update({
        status,
      });
    },

    async updateOnlineStatus() {
      if (this.isIdle) {
        this.changeOnlineStatusToAway();
      } else if (this.isAway) {
        this.changeOnlineStatusToAway();
      } else if (this.isPlayingMatch) {
        this.changeOnlineStatusToPlaying();
      } else if (this.isPlayingTournament) {
        this.changeOnlineStatusToPlaying();
      } else if (this.isBusy) {
        this.changeOnlineStatusToBusy();
      } else {
        this.changeOnlineStatusToActive();
      }
    },
  },
};
</script>
